module.exports = __webpack_public_path__ + "../resources/img/Web_Image_Solar.9170d539.svg";